import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BannerImg from "../../../images/locationgcc/bh/custom-made.webp";

function Banner(props) {
  return (
    <div
      className="revolution_gcc p-100"
      style={{ backgroundImage: `url(${BannerImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={12} xl={6} xxl={6} className="ms-auto">
            <h2>
              Capitalize on the Potential Market of Bahrain with Our Mobile App
              Development Company
            </h2>
            <p>
              Bahrain has become a focus of attention for the business world,
              especially in the GCC region due to its evolution in technology.
              For any organization, this is the right time for digitization and
              there is no better option than mobile app development to have a
              solid digital presence.
            </p>
            <p>
              With TekRevol, a successfully proven mobile app development
              company Bahrain, you can unlock the potential of your business to
              scale in this rapidly growing market. We ensure to build an
              on-demand app solution with a user-centric customization approach.
            </p>
            <p>
              As a result, you will have a competitive edge in the market
              leading towards robust mobile apps that will ensure higher ROI.
              So, consult with us today to discuss your project idea and
              initiate that path toward business sustainability by leveraging
              our app development services.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              {" "}
              Let’s Get Started
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
